import VueRouter from 'vue-router';
import Vue from 'vue';
import Dashboard from './components/Dashboard';
import DiaryList from './components/DiaryList';
import SiteDailyWorkRecord from './components/SiteDailyWorkRecord';
import SiteSafetyHealthMeasures from './components/SiteSafetyHealthMeasures';
import SiteWorkMonthlyResults from './components/SiteWorkMonthlyResults';
import ManualSearch from './components/ManualSearch';
import Callback from './components/Auth';
import Login from './components/Auth/Login.vue';
import ContractorSignIn from './components/Auth/ContractorSignIn';
import Health from './components/Health';
import { isAuthenticated, login, ensureAuthInitialized } from './api/AuthApi';
import contractorAuthApi from './api/ContractorAuthApi';

Vue.use(VueRouter);

const routes = [
  { 
    path: '/', 
    component: DiaryList,
    meta: { 
      requiresAuth: true 
    }
  },
  { 
    path: '/dashboard', 
    component: Dashboard,
    meta: { 
      requiresAuth: true 
    }
  },
  { 
    path: '/site-daily-work-record', 
    component: SiteDailyWorkRecord,
    meta: { 
      requiresAuth: true 
    }
  },
    { 
      path: '/site-safety-health-measures', 
      component: SiteSafetyHealthMeasures,
      meta: { 
        requiresAuth: true 
      }
    },
    { 
      path: '/site-work-monthly-results', 
      component: SiteWorkMonthlyResults,
      meta: { 
        requiresAuth: true 
      }
    },
    {
      path: '/manual-search',
      component: ManualSearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/callback',
    component: Callback
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: async (to, from, next) => {
      await login();
      next(false);
    }
  },
  {
    path: '/contractor/signin',
    name: 'contractor-signin',
    component: ContractorSignIn,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/health',
    component: Health
  }
];

const router = new VueRouter({
  mode: 'history', // HTML5 History モードを使用
  routes // short for `routes: routes`
});

// ナビゲーションガード
router.beforeEach(async (to, from, next) => {
  console.log('=== Router beforeEach Debug ===');
  console.log('From:', from.path, 'To:', to.path);
  console.log('Route params:', to.params);
  console.log('Route query:', to.query);
  console.log('Route meta:', to.meta);
  
  // Auth0の設定が存在するか確認
  const hasAuth0Config = process.env.VUE_APP_AUTH0_DOMAIN && process.env.VUE_APP_AUTH0_CLIENT_ID;
  console.log('Auth0 config exists:', hasAuth0Config);
  console.log('VUE_APP_AUTH0_DOMAIN:', process.env.VUE_APP_AUTH0_DOMAIN);
  console.log('VUE_APP_AUTH0_CLIENT_ID:', process.env.VUE_APP_AUTH0_CLIENT_ID);
  
  // Auth0が設定されている場合は初期化を確認
  if (hasAuth0Config) {
    console.log('Initializing Auth0...');
    await ensureAuthInitialized();
    console.log('Auth0 initialization completed');
  }
  
  // 認証が必要なルートの場合
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log('Router: Route requires authentication:', to.path);
    console.log('Matched routes:', to.matched.map(r => ({ path: r.path, meta: r.meta })));
    
    // 契約社員として認証済みかどうかをチェック
    const contractorToken = contractorAuthApi.getToken();
    const isContractorAuthenticated = contractorAuthApi.isAuthenticated();
    const isContractorTokenValid = contractorAuthApi.isTokenValid();
    console.log('Contractor token exists:', !!contractorToken);
    console.log('Contractor authenticated:', isContractorAuthenticated);
    console.log('Contractor token valid:', isContractorTokenValid);
    console.log('Contractor email:', contractorAuthApi.getUserEmail());
    
    // Auth0での認証状態もチェック
    const isAuth0Authenticated = hasAuth0Config && isAuthenticated();
    console.log('Auth0 authenticated:', isAuth0Authenticated);
    
    console.log('=== Authentication Status ===');
    console.log('Contractor auth result:', isContractorAuthenticated && isContractorTokenValid);
    console.log('Auth0 auth result:', isAuth0Authenticated);
    console.log('Overall auth result:', (isContractorAuthenticated && isContractorTokenValid) || isAuth0Authenticated);
    
    // どちらかの方法で認証済みの場合は通す
    if ((isContractorAuthenticated && isContractorTokenValid) || isAuth0Authenticated) {
      console.log('Router: Authentication successful, proceeding to route:', to.path);
      console.log('=== End Router Debug ===');
      next();
    } else {
      // 未認証の場合はログインページにリダイレクト
      console.log('Authentication required. Redirecting to login...');
      console.log('Current path:', from.path);
      console.log('Target path:', to.path);
      
      // 契約社員ログイン画面が既に表示されている場合は正社員ログインに
      if (from.path === '/contractor/signin') {
        console.log('Redirecting from contractor signin to regular login');
        console.log('=== End Router Debug ===');
        next({ path: '/login' });
      } else {
        // デフォルトは正社員ログイン
        console.log('Redirecting to regular login');
        console.log('=== End Router Debug ===');
        next({ path: '/login' });
      }
    }
  } else {
    // 認証が不要なルートの場合は通常通り進む
    console.log('Router: Route does not require authentication, proceeding');
    console.log('=== End Router Debug ===');
    next();
  }
});

export default router;
